<template>
  <ErrorBoundary>
    <ErrorBoundaryProbe />
    <GlobalLayout />
  </ErrorBoundary>
</template>

<script setup lang="ts">
import 'moment/dist/locale/fr'

import GlobalLayout from '@/(routes)/global-layout.vue'
import ErrorBoundary from '@/features/ui/components/error-boundary/error-boundary.vue'
import ErrorBoundaryProbe from '@/features/ui/components/error-boundary/error-boundary-probe.vue'
</script>

<style lang="scss">
@import './styles/global.scss';
</style>
